import { SubscriptionManagement } from "@Navigation/LazyImports";

export const NAVBAR_ITEMS_KEYS = {
  MAIN_MENU: "mainMenu",
  DASHBOARD: "dashboard",
  USER_MANAGEMENT: "user-management",
  PROFILE: "profile",
  SUBSCRIPTION_MANAGEMENT: "subscription-management",
};

export const NAVBAR_ITEMS_VALUES = {
  dashboard: "Dashboard",
  "user-management": "User Management",
  profile: "My Profile",
  "subscription-management": "Subscription Management",
};
